<template>
  <div class="uk-card uk-card-default uk-padding">
    <!--Окно ожидания при существующих заказах для взятия-->
    <!--    <div class="uk-padding uk-position-relative">
          <div class="uk-grid uk-flex-center uk-text-center" data-uk-grid>
            <div class="uk-width-large">
              <div class="tm-title-get-order">
                Вы можете взять заказ
              </div>
              <button class="uk-button uk-button-success tm-button-get-order uk-margin-medium" type="button">
                {{ local_page_keys.button_get_a_new_order }}
              </button>
              <div class="uk-margin-auto uk-margin-medium">
                <CountNewOrders :role="role" :local_page_keys="local_page_keys" ref="childRefNewOrders"/>
              </div>
            </div>
            <div class="uk-width-large">
              <div class="tm-title-get-order">
                Невозможно начать простой
              </div>
              <button class="uk-button tm-button-grey tm-button-get-order uk-margin-medium" type="button">
                Начать простой
              </button>
              <div class="uk-margin-auto uk-margin-medium">
                <div class="tm-order-count uk-box-shadow-medium">
                  <div tabindex="0" aria-haspopup="true">
                    <md-icon>schedule</md-icon> 48 мин
                  </div>
                  <div data-uk-dropdown="pos: bottom-center; offset: 15" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center">
                    Описание
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
    <!--Окно ожидания при отстутствии взятия на смену-->
    <!--    <div class="uk-padding uk-position-relative">
          <div class="uk-grid uk-flex-center uk-text-center" data-uk-grid>
            <div class="uk-width-large">
              <div class="tm-title-get-order">
                Вы не можете взять заказ
              </div>
              <button class="uk-button tm-button-pink tm-button-get-order uk-margin-medium" type="button">
                Вы не записаны на эту смену
              </button>
              <div class="uk-text-center uk-margin">
                <a href="" class="uk-link-text uk-text-meta" style="text-decoration: underline">
                  Хотите записаться?
                </a>
              </div>
              <div class="uk-margin-auto uk-margin-medium">
                <div class="tm-order-count uk-box-shadow-medium">
                  <div tabindex="0" aria-haspopup="true">
                    <md-icon>pending_actions</md-icon> 1 / 0
                  </div>
                  <div data-uk-dropdown="pos: bottom-center; offset: 15" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center">
                    Описание
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-width-large">
              <div class="tm-title-get-order">
                Невозможно начать простой
              </div>
              <button class="uk-button tm-button-grey tm-button-get-order uk-margin-medium" type="button">
                Начать простой
              </button>
              <div class="uk-margin-auto uk-margin-medium">
                <div class="tm-order-count uk-box-shadow-medium">
                  <div tabindex="0" aria-haspopup="true">
                    <md-icon>schedule</md-icon> 48 мин
                  </div>
                  <div data-uk-dropdown="pos: bottom-center; offset: 15" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center">
                    Описание
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
    <!--Окно ожидания при отстутствии заказов-->
    <!--    <div class="uk-padding uk-position-relative">
          <div class="uk-grid uk-flex-center uk-text-center" data-uk-grid>
            <div class="uk-width-large">
              <div class="tm-title-get-order">
                Нет свободных заказов
              </div>
              <button class="uk-button tm-button-grey tm-button-get-order uk-margin-medium" type="button">
                {{ local_page_keys.button_get_a_new_order }}
              </button>
              <div class="uk-margin-auto uk-margin-medium">
                <div class="tm-order-count uk-box-shadow-medium">
                  <div tabindex="0" aria-haspopup="true">
                    <md-icon>pending_actions</md-icon> 0 / 0
                  </div>
                  <div data-uk-dropdown="pos: bottom-center; offset: 15" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center">
                    Описание
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-width-large">
              <div class="tm-title-get-order">
                Вы можете начать простой
              </div>
              <button class="uk-button tm-button-blue tm-button-get-order uk-margin-medium" type="button">
                Начать простой
              </button>
              <div class="uk-margin-auto uk-margin-medium">
                <div class="tm-order-count uk-box-shadow-medium">
                  <div tabindex="0" aria-haspopup="true">
                    <md-icon>schedule</md-icon> 48 мин
                  </div>
                  <div data-uk-dropdown="pos: bottom-center; offset: 15" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center">
                    Описание
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
    <!--Окно ожидания при начатом простое-->
    <!--    <div class="uk-padding uk-position-relative">
          <div class="uk-grid uk-flex-center uk-text-center" data-uk-grid>
            <div class="uk-width-large">
              <div class="tm-title-get-order">
                Нет свободных заказов
              </div>
              <button class="uk-button tm-button-grey tm-button-get-order uk-margin-medium" type="button">
                {{ local_page_keys.button_get_a_new_order }}
              </button>
              <div class="uk-margin-auto uk-margin-medium">
                <div class="tm-order-count uk-box-shadow-medium">
                  <div tabindex="0" aria-haspopup="true">
                    <md-icon>pending_actions</md-icon> 0 / 0
                  </div>
                  <div data-uk-dropdown="pos: bottom-center; offset: 15" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center">
                    Описание
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-width-large">
              <div class="tm-title-get-order">
                Вы можете начать простой
              </div>
              <div class="uk-button tm-button-blue tm-button-get-order uk-margin-medium" style="font-size: 20px;font-weight: 700;">
                00:14:23
              </div>
              <div class="uk-margin-auto uk-margin-medium">
                <div class="tm-order-count uk-box-shadow-medium">
                  <div tabindex="0" aria-haspopup="true">
                    <md-icon>schedule</md-icon> 48 мин
                  </div>
                  <div data-uk-dropdown="pos: bottom-center; offset: 15" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center">
                    Описание
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

    <!--tg code-->
<!--    <div class="tm-background-green uk-light uk-padding-small uk-position-top-right" style="cursor: pointer">-->
<!--      <div>-->
<!--        <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid @click="copyTgCode(downtime.telegram_code.tg_code)">-->
<!--          <div>-->
<!--            <md-icon class="uk-light">content_copy</md-icon>-->
<!--          </div>-->
<!--          <div class="uk-text-bold">-->
<!--            TG code: {{ downtime.telegram_code.tg_code }}-->
<!--          </div>-->
<!--          <div>-->
<!--            <div class="uk-label tm-label uk-margin-small-left" style="display: inherit;">-->
<!--              {{ formattedTimeTgCode }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div style="width:300px" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 15">-->
<!--        {{local_page_keys.copy_telegram_code_popup}}-->
<!--      </div>-->
<!--    </div>-->

    <template v-if="!showTimer">
      <div class="uk-text-center">
        <template v-if="downtime.user_can_take_order">
          <div class="tm-title-get-order uk-flex-center">
            {{ local_page_keys.label_you_can_take_a_new_order }}
          </div>
<!--          <md-button class="uk-button uk-button-success tm-light"-->
<!--                     @click="getNewOrder()"-->
<!--                    :disabled="loading">-->
<!--            {{ local_page_keys.button_get_a_new_order }}-->
<!--            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>-->
<!--          </md-button>-->
          <button type="button" class="uk-button uk-button-success tm-light uk-margin-top" @click="getNewOrder()" :disabled="loading">
            {{ local_page_keys.button_get_a_new_order }}
            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
          </button>
        </template>
        <template v-else-if="!downtime.on_shift">
          <div class="uk-width-large uk-margin-auto">
            <div class="tm-title-get-order">
              {{local_page_keys.message_cant_take_the_order}}
            </div>
            <div class="uk-button tm-button-pink tm-button-get-order uk-margin-medium" style="cursor: inherit">
              {{local_page_keys.message_not_registered_for_this_shift}}
            </div>
            <div style="width:300px" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 5">
              {{local_page_keys.message_dropdown_not_registered_for_this_shift}}
            </div>
            <div class="uk-text-center uk-margin" v-if="!downtime.shift_is_full && !downtime.date_time_range_6_hours_shifts && !downtime.date_time_range_24_hours_shifts">
              <a href="javascript:void(0)" class="uk-link-text uk-text-meta" style="text-decoration: underline" @click="wantSignUp">
                {{local_page_keys.message_sign_up}}
              </a>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="uk-width-large uk-margin-auto uk-margin-top">
            <button disabled class="tm-button-grey uk-button">
              {{ local_page_keys.button_no_orders_in_the_queue }}
            </button>
          </div>
          <div style="width:300px" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 5">
            {{local_page_keys.button_no_orders_in_the_queue_popup}}
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="uk-text-center">
        <!--Вы выполнили заказ временно скрыт RA-501 -->
        <div v-if="false" class="uk-background-muted uk-padding uk-margin-auto uk-margin-medium uk-width-xlarge uk-border-rounded uk-text-large uk-box-shadow-small">
          <div class="uk-margin">
            {{ local_page_keys.label_you_have_completed_the_order }}
          </div>
          <div class="uk-grid uk-grid-small uk-flex-center uk-margin-top" data-uk-grid>
            <div v-if="orderdays >= 1">
              {{ orderdays ? orderdays : 0 }} {{ local_page_keys.label_timer_days }}
            </div>
            <div v-if="orderdays < 1 && hours >= 1">
              {{ hours ? hours : 0 }} {{ local_page_keys.label_timer_hours }}
            </div>
            <div v-else-if="orderdays >= 1">
              {{ hours ? hours : 0 }} {{ local_page_keys.label_timer_hours }}
            </div>
            <div>
              {{ minutes ? minutes : 0 }} {{ local_page_keys.label_timer_minutes }}
            </div>
            <div>
              {{ seconds ? seconds : 0 }} {{ local_page_keys.label_timer_seconds }}
            </div>
            <div class="uk-text-lowercase">
              {{ local_page_keys.button_back }}
            </div>
          </div>
        </div>

        <div class="uk-grid uk-flex-center uk-text-center" data-uk-grid>
          <!--<template v-if="downtime.is_orders_to_work !== false && (downtime.on_shift || personal_orders_count > 0)">-->
          <template v-if="downtime.user_can_take_order">
            <div class="uk-width-large uk-margin-auto">
<!--              <md-button class="md-success" @click="getNewOrder()" :disabled="loading">-->
<!--                {{ local_page_keys.button_get_a_new_order }}-->
<!--                <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>-->
<!--              </md-button>-->
              <button type="button" class="uk-button uk-button-success tm-light uk-margin-top" @click="getNewOrder()" :disabled="loading">
                {{ local_page_keys.button_get_a_new_order }}
                <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
              </button>
            </div>
          </template>
          <template v-else-if="!downtime.on_shift">
            <div class="uk-width-large uk-margin-auto">
              <div class="tm-title-get-order">
                {{local_page_keys.message_cant_take_the_order}}
              </div>
              <div class="uk-button tm-button-pink tm-button-get-order uk-margin-medium" style="cursor: inherit">
                {{local_page_keys.message_not_registered_for_this_shift}}
              </div>
              <div style="width:300px" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 5">
                {{local_page_keys.message_dropdown_not_registered_for_this_shift}}
              </div>
              <div class="uk-text-center uk-margin">
                <a href="javascript:void(0)" v-if="!downtime.shift_is_full" class="uk-link-text uk-text-meta" style="text-decoration: underline" @click="wantSignUp">
                  {{local_page_keys.message_sign_up}}
                </a>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="uk-width-large uk-margin-auto uk-margin-top">
              <button disabled class="tm-button-grey uk-button">
                {{ local_page_keys.button_no_orders_in_the_queue }}
              </button>
            </div>
            <div style="width:300px" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom-center; delay-hide: 400; delay-show: 0; offset: 5">
                {{local_page_keys.button_no_orders_in_the_queue_popup}}
            </div>
          </template>
        </div>
      </div>
    </template>

    <div class="uk-margin-auto uk-margin-top">
      <CountNewOrders :role="role"
                      :local_page_keys="local_page_keys"
                      ref="childRefNewOrders"
                      :downtime="downtime"/>
    </div>
  </div>
</template>

<script>

import CountNewOrders from "@/pages/Dashboard/Components/CountNewOrders";

export default {
  name: "RetouchersInactivityTimer",
  components: {CountNewOrders},
  props: {
    downtime: {},
  },
  data: () => ({
    orderdays: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    showTimer: false,
    interval: null,
    interval2: null,
    orderDateTime: null,
    local_page_keys: {},
    orderCurrDate: null,
    role: '',
    //countdown: 100,
    intervalId: null,
    loading:false,
  }),
  methods: {
    diffOrderMinutes(data) {
      let orderDate = this.orderDateTime !== null ? this.orderDateTime : Date.now();
      this.showTimer = (orderDate === this.orderDateTime ? true : false);
      let diff = this.orderCurrDate - orderDate;
      if (data === 'minutes') {
        return Math.floor((diff % 3.6e6) / 6e4);
      } else if (data === 'hours') {
        let hours = Math.floor(diff / 3.6e6);
        if (hours > 24) {
          let days = Math.floor(hours / 24);
          hours = hours - 24 * days;
        }
        return hours;
      } else if (data === 'seconds') {
        return Math.floor((diff % 60000) / 1000);
      } else if (data === 'days') {
        let hours = Math.floor(diff / 3.6e6);
        return Math.floor(hours / 24);
      }
    },
    async getNewOrder() {
      //this.$emit('is-loading', true);
      this.loading = true;
      let data;
      if (this.role === 'test-retoucher') {
        await this.$store.dispatch("order/getNewOrder", 'retoucher')
      } else {
        await this.$store.dispatch("order/getNewOrder");
      }
      data = this.$store.getters["order/getNewOrder"];
      // if (data.status === "ok") {
      //   this.$emit('retry', true);
      // } else {
      //   this.$emit('retry', true);
      // }
      this.$emit('retry', true);
      //this.$emit('is-loading', false);
      this.loading = false;
    },
    async wantSignUp() {

      // let updateParams = {date, time, msg, retoucher, week, view, keyLockIstoSet, dataToUpdate}
      // let params = { urlToUpdate, updateParams};
      let message = this.local_page_keys.alert_confirm_sign_up;

      if (confirm(message)) {
        await this.$store.dispatch("schedule/scheduleRetoucherSignUpNow");
      }

    },
    // copyTgCode(code) {
    //   if (code) {
    //     const input = document.createElement('input');
    //     input.value = code;
    //     document.body.appendChild(input);
    //     input.select();
    //     const successful = document.execCommand('copy');
    //     document.body.removeChild(input);
    //     if (successful) {
    //       UIkit.notification({
    //         message: this.local_page_keys.copy_telegram_code,
    //         pos: 'top-center',
    //         status: 'primary',
    //         timeout: 1500
    //       })
    //     }
    //   }
    // },
    // startCountdown() {
    //   this.intervalId = setInterval(() => {
    //     if (this.countdown > 0) {
    //       this.countdown--;
    //     } else {
    //       clearInterval(this.intervalId);
    //     }
    //   }, 1000); // Обновляем каждую секунду
    // },
  },
  watch: {
    'downtime.now': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if(this.$refs.childRefNewOrders && typeof this.$refs.childRefNewOrders.fetchCountNewOrders === 'function'){
          this.$refs.childRefNewOrders.fetchCountNewOrders();
        }
      }
    },
    // 'downtime.telegram_code.unix_time': function (newUnixTime, oldUnixTime) {
    //   if (newUnixTime !== oldUnixTime) {
    //     // Обновляем счетчик обратного отсчета
    //     this.countdown = 100;
    //     // Перезапускаем счетчик
    //     clearInterval(this.intervalId);
    //     this.startCountdown();
    //   }
    // },
  },
  computed: {
    // formattedTimeTgCode() {
    //   const minutes = Math.floor(this.countdown / 60);
    //   const seconds = this.countdown % 60;
    //   // Форматируем минуты и секунды как двузначные числа
    //   const formattedMinutes = String(minutes).padStart(2, '0');
    //   const formattedSeconds = String(seconds).padStart(2, '0');
    //
    //   return `${formattedMinutes}:${formattedSeconds}`;
    // }
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('order-downtime');
    this.role = await this.$store.getters['profile/role'];
    this.showTimer = this.downtime.inactivity_timer_start !== null;
    if (this.downtime.inactivity_timer_start !== null) {
      this.orderCurrDate = Object.keys(this.downtime).includes('now') ? Date.parse(this.downtime.now) : Date.now();
      this.orderDateTime = Date.parse(this.downtime.inactivity_timer_start);
      this.interval = setInterval(() => {
        this.orderCurrDate += 1000;
        this.seconds = this.diffOrderMinutes('seconds');
        this.minutes = this.diffOrderMinutes('minutes');
        this.hours = this.diffOrderMinutes('hours');
        this.orderdays = this.diffOrderMinutes('days');
      }, 1000);
    }
    this.interval2 = setInterval(() => {
      this.$emit('retry', true);
    }, 2000);

    //this.startCountdown();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.interval2);
  }

}
</script>

<style></style>